import COMPANY_API from '@/api/dataBase';
export const formColumn = (ctx) => {
  return [
    {
      prop: 'platformCompanyCode',
      name: '公司名称',
      type: 'ajaxSelect',
      apiUrl: COMPANY_API.GET_PERSON_API,
      apiData: {
        id: ctx.userInfo.userCode,
        userCode: ctx.userInfo.userCode,
        personName: ctx.userInfo.userName,
      },
      dataString: 'data.personCompanyInfo',
      clearable: true,
      filterable: true,
      valueKey: 'personCompanyCode',
      labelKey: 'personCompanyName',
      changeMethod: 'changeMethod',
      method: 'post',
    },
    {
      prop: 'contractBusinessDepartment',
      name: '部门',
      type: 'select',
      options: ctx.departmentList,
      filterable: true,
    },
    {
      prop: 'projectInitiationNo',
      name: '项目名称',
      // searchType: 'projectListWumao',
      searchType: 'projectListWumaoByPage',
      type: 'searchTableSpec',
      isMultiple: true,
      // currentValue: ctx.query?.projectName ? ctx.query?.projectName : null,
      // checkRowKeys: [ctx.query.projectInitiationNo ? ctx.query.projectInitiationNo : null],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        applyDepartmentNoList: ctx.query.contractBusinessDepartment
          ? [ctx.query.contractBusinessDepartment]
          : (ctx.userInfo.allDepartmentList || []).map((v) => v.personDepartmentCode),
        // applyDepartmentNo: ctx.userInfo.departmentCode,
        // businessGroup: ctx.userInfo.businessGroup,
        //   applyCompanyNo: ctx.query.companyCode,
        // applyDepartmentNo: ctx.query.contractBusinessDepartment,
        //   platformtCompany: ctx.query.companyCode,
        // applyDepartmentName: ctx.query.contractBusinessDepartmentName,
        //   applyCompanyName: ctx.userInfo.userInfo.companyName,
        //   latformtCompanyName: ctx.userInfo.userInfo.companyName,
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerNo',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
        // departmentCode:
        //   ctx.query.contractBusinessDepartment && ctx.query.contractBusinessDepartment.length != 0
        //     ? ctx.query.contractBusinessDepartment
        //     : ctx.userInfo.userInfo.departmentCode,
        // companyCode: ctx.userInfo.userInfo.companyCode, //公司
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '合同编号',
      prop: 'contractNoLike',
      type: 'searchTableSpec',
      searchType: 'wumaoContract',
      extraData: {
        contractCategory: 'sales',
        // companyCode: ctx.query.platformCompanyCode,
        // departmentCode: ctx.query.contractBusinessDepartmentNo,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
  ];
};

export const defaultTableColumn = (ctx) => {
  return [
    // { type: 'seq', title: '序号', width: 50 },
    {
      field: 'contractNo',
      title: '合同号',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '项目编号',
      visible: true,
    },
    {
      field: 'projectName',
      title: '项目名称',
      visible: true,
    },
    {
      title: '客户名称',
      field: 'customerName',
    },
    {
      title: '录入方式',
      field: 'isManual',
    },
    {
      title: '开票日期',
      field: 'invoiceDate',
    },
    {
      title: '发货日期',
      field: 'deliveryDate',
      visible: true,
    },
    // ?
    {
      title: '下游应付款日期（账期T天+5天）',
      field: 'returnedDate',
      visible: true,
    },
    {
      title: '下游实际回款日期',
      field: 'actualCollectionDate',
      visible: true,
    },
    // 固定100%
    {
      title: '比例',
      field: 'rate',
      visible: true,
    },
    {
      title: '开票金额',
      field: 'invoiceAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },
    // 即开票金额
    {
      title: '比例金额',
      field: 'rateAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },
    // // ?
    // {
    //   title: '数量（吨）',
    //   field: 'noInvoicedRevenue',
    //   visible: true,
    // },

    {
      title: '下游实际回款金额',
      field: 'allocationAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },

    {
      title: '下游实际累计逾期金额',
      field: 'accumulateOverdueAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '剩余应付未付金额',
      field: 'remainUnpaidAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '逾期天数',
      field: 'overdueDays',
      visible: true,
    },
    {
      title: '日利率（‰）',
      field: 'liquidatedInterestRateThousand',
      visible: true,
    },
    {
      title: '违约金金额（按日利率）',
      field: 'liquidatedAmountDailyRate',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '违约金金额（按固定金额）',
      field: 'liquidatedAmountFixed',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '违约金金额（其他）',
      field: 'liquidatedAmountOther',
      visible: true,
      formatter: ctx.formatterNum,
    },
  ];
};

export const addFormColumns = (ctx) => {
  return [
    // {
    //   name: '发票',
    //   prop: 'invoice',
    //   type: 'searchTableSpec',
    //   searchType: 'liquidatedDamagesInvoice',
    //   defaultQuery: {
    //     contractNo: ctx.query.contractNo,
    //   },
    //   extraData: {
    //     contractCategory: 'sales',
    //     contractNo: ctx.query.contractNo,
    //   },
    //   changeMethod: 'changeMethod',
    //   isMultiple: true,
    // },
    {
      prop: 'projectInitiationNo',
      name: '项目名称',
      searchType: 'projectListWumaoByPage',
      type: 'searchTableSpec',
      currentValue: ctx.query.projectName,
      isMultiple: true,
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        applyDepartmentNoList: (ctx.userInfo.allDepartmentList || []).map(
          (v) => v.personDepartmentCode
        ),
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'liquidatedDamagesContract',
      extraData: {
        contractCategory: 'sales',
        projectInitiationNo: ctx.query.projectInitiationNo,
      },
      defaultQuery: {
        projectInitiationNo: ctx.query.projectInitiationNo,
      },
      currentValue: ctx.query.contractNo,
      changeMethod: 'changeMethod',
      isMultiple: true,
      disabled: !ctx.query.projectInitiationNo,
    },
    {
      prop: 'customerName',
      // type: 'searchTableSpec',
      type: 'input',
      disabled: true,
      name: '客户名称',
      // searchType: 'supplier',
      // extraData: {
      //   partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      // },
      // isMultiple: true,
      // changeMethod: 'changeMethod',
    },
    {
      prop: 'settlementDate',
      type: 'select',
      name: '结算日类型',
      isMultiple: true,
      options: [
        {
          label: '开票日期',
          value: '0',
        },
        {
          label: '发货日期',
          value: '1',
        },
      ],
    },
    {
      prop: 'invoiceDate',
      type: 'date',
      name: '开票日期',
      isMultiple: true,
      changeMethod: 'changeMethod',
      isHidden: !(ctx.query.settlementDate == '0'),
    },
    {
      prop: 'deliveryDate',
      type: 'date',
      name: '发货日期',
      isMultiple: true,
      isHidden: !(ctx.query.settlementDate == '1'),
      changeMethod: 'changeMethod',
    },
    {
      prop: 'returnedDate',
      type: 'date',
      name: '下游应付款日期（账期T天+5天）',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'actualCollectionDate',
      type: 'date',
      name: '下游实际回款日期',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      type: 'inputNumber',
      precision: 0,
      max: 100,
      min: 0,
      prop: 'rate',
      name: '比例',
      changeMethod: 'changeMethod',
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'invoiceAmount',
      name: '开票金额',
      changeMethod: 'changeMethod',
    },
    // {
    //   type: 'inputNumber',
    //   precision: 3,
    //   prop: 'invoiceAmount',
    //   name: '比例金额',
    //   disabled: true,
    // },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'allocationAmount',
      name: '下游实际回款金额',
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'accumulateOverdueAmount',
      name: '下游实际累计逾期金额',
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'remainUnpaidAmount',
      name: '剩余应付未付金额',
    },
    {
      type: 'inputNumber',
      precision: 0,
      prop: 'overdueDays',
      name: '逾期天数',
    },
    {
      type: 'select',
      prop: 'liquidatedDamagesType',
      name: '违约金类型',
      options: [
        {
          value: 'FIXED',
          label: '按固定值',
        },
        {
          value: 'RATE',
          label: '按利率',
        },
        {
          value: 'OTHER',
          label: '其他',
        },
      ],
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'liquidatedInterestRateThousand',
      name: '日利率（‰）',
      isHidden: ctx.query.liquidatedDamagesType !== 'RATE',
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'liquidatedAmountDailyRate',
      name: '违约金金额',
      isHidden: !(ctx.query.liquidatedDamagesType == 'RATE'),
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'liquidatedAmountFixed',
      name: '违约金金额',
      isHidden: !(ctx.query.liquidatedDamagesType == 'FIXED'),
    },
    {
      type: 'inputNumber',
      precision: 3,
      prop: 'liquidatedAmountOther',
      name: '违约金金额',
      isHidden: !(ctx.query.liquidatedDamagesType == 'OTHER'),
    },
  ];
};

export const formRules = {
  projectInitiationNo: [{ required: true, message: '请选择项目' }],
  contractNo: [{ required: true, message: '请选择合同' }],
  // projectInitiationNo: [{ required: true, message: '请选择项目' }],
};
// export default formColumn;
